import React from 'react'
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer__container container">
            <h1 className="section__title">Azmrfii</h1>

            <ul className="footer__list">
                <li>
                    <a href="#about" className="footer__link">About</a>
                </li>
                <li>
                    <a href="#portfolio" className="footer__link">Projects</a>
                </li>
                <li>
                    <a href="#contact" className="footer__link">Contact</a>
                </li>
            </ul>
            <div className="footer__social">
            <a href="https://www.instagram.com/azmrfii/" className="footer__social-link" target='_blank'>
                <i className="bx bxl-instagram"></i>
            </a>
            <a href="https://github.com/azmrfii/" className="footer__social-link" target='_blank'>
                <i className="bx bxl-github"></i>
            </a>
            <a href="https://www.linkedin.com/in/azzamrafizafran/" className="footer__social-link" target='_blank'>
                <i className="bx bxl-linkedin"></i>
            </a>
            </div>

            <span className="footer__copy">
                &#169; Azmrfii. All right reserved.
            </span>
        </div>
    </footer>
  )
}

export default Footer